import React from "react";
import { SeeYouSoonBlockEl } from './styles';
import line from '../../assets/line.svg';

export const SeeYouSoonBlock = () => {
    return (
        <SeeYouSoonBlockEl alt={'see you soon'} src={line} />
    );
}
